import * as React from "react";
const SvgSignalCellular4BarOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M0 0h24v24H0V0z" />
    <path d="M2 22h20V2L2 22z" />
  </svg>
);
export default SvgSignalCellular4BarOutlined;
